import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  connect () {
    const urlParams = new URLSearchParams(window.location.search);
    const activeTabs = urlParams.getAll('tabs[]');

    activeTabs.forEach((activeTab) => {
      const link = this.linkTargets.find((link) => link.dataset.bsTarget.substring(1) === activeTab);

      if (link) {
        link.click();
      }
    });
  }

  linkTargetConnected(element) {
    element.addEventListener('click', this.registerHistory);
  }

  registerHistory(event) {
    const target = event.currentTarget;

    if (target.dataset.tabsIgnoreHistory) return;

    const tabName = target.dataset.tabsName;
    if (!tabName) return;

    const urlParams = new URLSearchParams(window.location.search);
    const url = new URL(location);

    const activeTabs = urlParams.getAll('tabs[]');
    urlParams.delete('tabs[]');
    const nextTabs = [...new Set([...activeTabs.filter((t) => t !== tabName), tabName])];
    nextTabs.forEach((t) => urlParams.append('tabs[]', t));

    history.pushState({}, '', `${url.origin}${url.pathname}?${urlParams.toString()}`);
  }
}
